import StatusEnum from 'axios/enum';
import { Iresponse } from 'axios/type';
import { APP_PATH } from 'config';
import { addDays, addYears, differenceInDays } from 'date-fns';
import { EnumLangContent, EnumLanguage } from 'i18n/type';
import {
  DeepRequired,
  FieldError,
  FieldErrorsImpl,
  Merge,
} from 'react-hook-form';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { EnumLayoutRouter } from 'router/enum';
import { HelperTextProps } from 'tradevan-ui/Form/HelperText';

export const localStorageRetaierIdName = 'retaierId';
/** 使用多國語系 */
export const useI18n = () => {
  const { t, i18n } = useTranslation();

  /** 更改語言 */
  const changeLang = (lang: EnumLanguage | string) => {
    i18n.changeLanguage(lang);
  };

  /** 目前的語言 */
  const lang = i18n.language;
  /**
   * 取得翻譯文字
   * @param val 文字
   * @param language 預設為當前語言，也可帶入指定語言
   * @returns
   */
  const getApiContent = (val: EnumLangContent, language?: EnumLanguage) => {
    return t(`${language || i18n.language}.${val}`);
  };

  const getLocalContent = (val: EnumLangContent) => {
    return t(val);
  };

  return { changeLang, getApiContent, getLocalContent, lang };
};
/** 顯示 response snackBar */
export const showResponseSnackBar = (
  response: Iresponse | undefined,
  successShow = false,
) => {
  if (response) {
    const { status, message = '' } = response;

    switch (status) {
      case StatusEnum.完成:
        if (message.length > 0) {
          toast.error(message, { duration: 3000 });
          return;
        }
        if (successShow) {
          toast.success(message, { duration: 3000 });
        }
        return;

      default:
        toast.error(message);
    }
  }
};

export const showSnackBar = (
  message: string,
  icon: 'success' | 'error',
  duration?: number,
) => {
  switch (icon) {
    case 'success':
      toast.success(message, { duration: duration || 3000 });
      break;
    case 'error':
      toast.error(message, { duration: duration || undefined });
      break;

    default:
      break;
  }
};

/** hook-form error to HelperTextProps */
export const getErrorHelperText = (
  err:
    | Merge<FieldError, (FieldError | undefined)[]>
    | FieldError
    | Merge<FieldError, FieldErrorsImpl<DeepRequired<Date>>>
    | undefined,
): HelperTextProps => ({
  error: (err?.message || '').length > 0,
  helperText: err?.message || '',
});

/**
 * TTT
 * 回傳範圍日期錯誤字串
 * @param sDate 開始日期
 * @param eDate 結束日期
 * @param range 日期可容許間隔
 * @returns
 */
export const dateRangeValidate = (
  sDate: Date | null,
  eDate: Date | null,
  range: number,
) => {
  if (sDate && eDate) {
    // 兩個日期的間格天數
    const differenceInDaysVal = Math.abs(differenceInDays(sDate, eDate));
    if (sDate > eDate) {
      return '起始日期不得大於結束日期。';
    }
    if (differenceInDaysVal > range) {
      return `起訖日期範圍不可超過${range}天。`;
    }
  }
  return undefined;
};

/** 加上 APP_PATH */
export const getLayoutLinkString = (url: EnumLayoutRouter) => {
  return `${APP_PATH}${url}`.toLowerCase();
};

/** 下載檔案  */
export const downloadFileByUrl = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', decodeURIComponent(''));
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(link.href);
};
/** 操作手冊清單 */
export const PDF_FILE_LIST = [
  'CSM', // CitySuper
  'SSE', // 爭鮮
  'IKL', // 億客成
  '16347534', // 普來利
  'STN', // 信東
  'TMK', // 松本清
  'TCP', // 德昌藥局
  '89878740', // 四季精品
  '86622169', // 喜互惠
  '84501598', // 怡客咖啡
  'TCS', // 墊腳石
  '84078213', // 喜美
  '16344895', // 美康
  'SAS', // 大買家
  '80234156', // 佳瑪
  '13168852', // 九乘九
  '97145410', // 金玉堂
];

export const DATE_RANGE_DEFAULT = {
  // startDate: addDays(new Date(), -7),
  startDate: new Date(),
  endDate: new Date(),
};

export const DATE_RANGE_CONFIG = {
  maxDate: addYears(new Date(), 2),
  minDate: addYears(new Date(), -2),
};
